import WebpackerReact from 'webpacker-react';
import 'styles/public';
import LocalTime from 'local-time';
import Alerts from 'components/Alerts';
import Ideas from 'components/Ideas';
import RssFeedButton from 'components/RssFeedButton';

LocalTime.start();

WebpackerReact.setup({
  Alerts,
  Ideas,
  RssFeedButton,
});

// Scroll overflow hints for roadmap board columns
let scrollHintsCleanup: (() => void)[] = [];

function initScrollHints() {
  scrollHintsCleanup.forEach((cleanup) => cleanup());
  scrollHintsCleanup = [];

  document.querySelectorAll<HTMLElement>('.stages-scroll-wrapper').forEach((wrapper) => {
    const scroller = wrapper.querySelector<HTMLElement>('.stages-container');
    if (!scroller) return;

    function update() {
      const { scrollLeft, scrollWidth, clientWidth } = scroller!;
      wrapper.classList.toggle('can-scroll-left', scrollLeft > 0);
      wrapper.classList.toggle('can-scroll-right', scrollLeft + clientWidth < scrollWidth - 1);
    }

    scroller.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    scrollHintsCleanup.push(() => window.removeEventListener('resize', update));
    update();
  });
}

function scrollToHashAnchor() {
  const { hash } = window.location;
  if (!hash) return;

  const id = decodeURIComponent(hash.slice(1));
  const target = document.getElementById(id);

  if (target) {
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

document.addEventListener('turbo:load', initScrollHints);
document.addEventListener('DOMContentLoaded', initScrollHints);
document.addEventListener('turbo:load', scrollToHashAnchor);
